import { BANNER_CLICK } from './../constants'
import { GtmAgent } from './GtmAgent'

// Banner 模組的 banner 名稱欄位為 title
export const sendBannerClick = ({
  banner,
  moduleId,
  bannerLocation,
  venderName,
  venderId,
}) => {
  if (!banner) {
    throw new Error('Banner is empty. Can not send GTM data')
  }
  GtmAgent.directSendToGTM({
    event: BANNER_CLICK,
    living_bnid: banner?._id,
  })
  GtmAgent.directSendToGTM({
    event: 'living_action',
    living_event_name: 'banner_click',
    living_banner_name: banner?.name || banner?.title,
    living_banner_id: banner?._id,
    ...(moduleId && { living_module_id: moduleId }),
    ...(bannerLocation && { living_banner_location: bannerLocation }),
    ...(venderName && { living_vender: venderName }),
    ...(venderId && { living_vender_id: venderId }),
  })
}
